export type PageReference = {
  _content_type_uid: string;
  reference?: PageReference[];
};

export type Page = {
  url?: string;
  heading: PageReference[];
  content: PageReference[];
  sidebar: PageReference[];
  offers_table_content?: PageReference[];
};

export const getPageModulesList = (page?: Page): string[] => {
  if (!page) {
    return [];
  }
  const layoutModule = page.content?.find(
    ({ _content_type_uid }) => _content_type_uid === 'layout_container',
  );
  return [
    ...new Set(
      [
        ...(page.heading ?? []),
        ...(page.content ?? []),
        ...(page.sidebar ?? []),
        ...(page?.offers_table_content ?? []),
        ...(layoutModule?.reference ?? []),
      ].map((module) => module._content_type_uid),
    ),
  ];
};
